import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css } from 'styled-components'
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, bgIcon, padding, hoverState, bgImage, innerContainer } from '../../../styles/global'
import { ribbon } from '../../../styles/colors';
import { paragraph } from '../../../styles/type';

class BlockTextMedia extends React.Component {

	state = {
	
	}
	
	render() {
		const { image, video_custom_mp4, cover_image, text, text_position } = this.props;
        
		return (
			<React.Fragment>
				<Media
					textPosition={text_position}
				>
					{image && (
						<Image
							src={image.sizes.medium_large}
						/>
					)}

					{video_custom_mp4 && (
						<Video
							coverImage={cover_image.sizes.medium_large}
							video={video_custom_mp4.filename}
						/>
					)}
				</Media>

				<Text
					dangerouslySetInnerHTML={{__html: text}}
					textPosition={text_position}
				/>
			</React.Fragment>
		)
	}
}

const Media = styled.div`
	height: 620px;

	${media.laptop`
		height: 512px;
	`}

	${media.tablet`
		height: 420px;
	`}

	${media.phone`
		display: flex;
		justify-content: center;
	`}

	${props => {
		if (props.textPosition == 'left') return css`
			padding-left: 2.5rem; /* half gutter size */
		`
	}}

	${props => {
		if (props.textPosition == 'right') return css`
			padding-right: 2.5rem; /* half gutter size */
		`
	}}
`

const Image = styled.img`
	background-image: url(${props => props.image});
	${bgImage}
	height: auto;
	width: auto;
	max-height: 100%;
	max-width: 100%;

	${media.phone`
		max-width: 295px;
	`}
`

const Video = styled.div`
	width: 100%;
	height: 100%;

	${props => {
		if (props.coverImage) return css`
			background-image: url(${props => props.coverImage});
			${bgImage}
		`
	}}
`

const Text = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;

	${media.phone`
		display: block;
		margin-top: 5rem;
		width: 360px;
		max-width: 100%;
		margin-left: auto;
		margin-right: auto;
	`}

	> * {
		${paragraph};
	}

	${props => {
		if (props.textPosition == 'left') return css`
			order: -1;
			padding-right: 2.5rem; /* half gutter size */

			${media.phone`
				order: initial;
			`}
		`
	}}
	${props => {
		if (props.textPosition == 'right') return css`
			padding-left: 2.5rem; /* half gutter size */
		`
	}}
`

// layout
BlockTextMedia.wrapper = css`
	${innerContainer};
	display: flex;
	margin-left: auto;
	margin-right: auto;

	${media.phone`
		flex-direction: column;
	`}

	${Media}, ${Text} {
		flex: 50%;
		box-sizing: border-box;

		${media.phone`
			flex: none;
			padding: 0;
		`}
	}
`

export default BlockTextMedia



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockTextMedia.js